import React from "react";

export const EuropeanLicensePlate = ({ plate = "", size = "md" }) => {
  const sizes = {
    sm: { text: "text-sm", py: "py-0.5", px: "px-2", strip: "w-5 text-[8px]", stars: "text-[10px]" },
    md: { text: "text-lg", py: "py-1", px: "px-3", strip: "w-7 text-[10px]", stars: "text-sm" },
    lg: { text: "text-2xl", py: "py-1.5", px: "px-4", strip: "w-9 text-xs", stars: "text-lg" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      data-testid="european-plate"
      className="inline-flex items-stretch border-2 border-black bg-white overflow-hidden"
      style={{ fontFamily: "'JetBrains Mono', monospace" }}
    >
      <div
        className={`bg-[#003399] text-white flex flex-col items-center justify-center ${s.strip}`}
        aria-hidden
      >
        <span className={`${s.stars} text-yellow-300 leading-none`}>★</span>
        <span className="font-black leading-none mt-0.5">I</span>
      </div>
      <div className={`flex items-center justify-center ${s.px} ${s.py}`}>
        <span className={`font-black tracking-widest text-black ${s.text} uppercase`}>
          {plate || "—"}
        </span>
      </div>
    </div>
  );
};

export default EuropeanLicensePlate;
